<template>
  <section>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
      <Card :bordered="false" dis-hover>
        <Form-item label="">
          <div class="select-container">
            <div class="chose-input" @click="visiable = true">
              {{areaNameList.join(",")}}
            </div>
            <Button
              type="primary"
              style="margin-left: -5px; height: 48px"
              icon="ios-search"
              @click="visiable = true"
              >选择区域</Button
            >
          </div>
        </Form-item>
        <Form-item label="服务商" prop="addOptUser">
          <Select
            v-model="spCode"
            placeholder="请选择服务商"
            class="public-inp"
          >
            <Option
              v-for="item in spInfoQueryAll || []"
              :key="item.code"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </Form-item>

        <FormItem style="margin-left: 15px" class="br">
          <Button @click="handleSave" type="primary">保存</Button>
          <Button @click="handleReset" style="margin-left: 10px">取消</Button>
        </FormItem>
      </Card>
    </Form>
    <Modal v-model="visiable" :footer-hide="true">
      <citySelect
        @on-save="getArea"
        @on-cancel="visiable = false"
      />
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import citySelect from "../../components/citySelect.vue";
export default {
  name: "skuSpEdit",
  data() {
    return {
      formValidate: {},
      ruleValidate: {},
      addressData: [],
      spCode: "",
      areaCodeList: [],
      areaNameList: [],
      visiable: false,
    };
  },
  computed: {
    ...mapGetters({
      // baseAreaAll: "getBaseAreaAll",
      spInfoQueryAll: "merchant/getSpInfoQueryAll",
    }),
  },
  components: { citySelect },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch("base/getBaseAreaAll").then((res) => {
        const addressData = this.convertTree(res);
        this.addressData = addressData;
      });

      // 查询资金商&服务商
      this.$store.dispatch("merchant/getSpInfoQueryAll");
    },
    getArea(list) {
      console.log(list)
      const areaCodeList = [];
      const areaNameList = [];
      Object.keys(list).forEach((key) => {
        list[key]
          .filter((i) => !!i)
          .forEach((a) => {
            areaCodeList.push(a.code)
            areaNameList.push(a.name)
          });
      });
      this.areaCodeList = areaCodeList;
      this.areaNameList = areaNameList;
      this.visiable = false;
    },
    handleSave() {
      this.$store.dispatch("shop/shopAreaMainSpUpdateArea", {
        "areaCodeList": this.areaCodeList || [],
        "spCode": this.spCode || ""
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success("设置成功");
          setTimeout(() =>{
            this.handleReset()
          }, 1000)
        } else {
          this.$Message.error(res.message || "设置失败");
        }
      });
    },
    handleReset() {
      this.$router.back();
    },
    convertTree(tree) {
      const result = [];

      tree.forEach((item) => {
        let { atpids: value, areaName: label, children } = item;
        if (children) {
          children = this.convertTree(children);
        }
        result.push({ value, label, children });
      });
      return result;
    },
  },
};
</script>

<style>
.select-container {
  display: flex;
  align-items: center;
}
.chose-input {
  width: 500px;
  height: 48px;
  border: 1px solid #5586ff;
  border-radius: 5px;
  padding: 8px;
  white-space: nowrap;
  overflow: hidden;
}
.chose-item {
  display: inline-block;
  width: auto;
  height: 32px;
  background: #5586ff;
  border-radius: 5px;
  padding: 0 8px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/commodity/skuAreaManageSet.vue